import React from "react";
import { DataManColumnContext } from "../defines";
import { DataManColumnState } from "../types/columns";

export interface DataManColumnProviderProps
  extends Pick<
    DataManColumnState,
    | "column"
    | "isActionColumn"
    | "isOptionsColumn"
    | "isSelectionColumn"
    | "isSortableHandler"
  > {
  children: React.ReactNode;
}

export const DataManColumnProvider: React.FC<DataManColumnProviderProps> = ({
  children,
  isActionColumn,
  isOptionsColumn,
  isSelectionColumn,
  isSortableHandler,
  column
}) => {
  return (
    <DataManColumnContext.Provider
      value={{
        column,
        isActionColumn,
        isOptionsColumn,
        isSelectionColumn,
        isSortableHandler
      }}
    >
      {children}
    </DataManColumnContext.Provider>
  );
};
